<div class="dialog-container">
  <ngx-spinner type="ball-atom"></ngx-spinner>
  <h2 mat-dialog-title class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>OPB Companies CSV Import</h2>

  <div mat-dialog-content>
    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Upload CSV
      </div>
      <div class="section-content">
        <div class="search-fields">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Delimiter</mat-label>
            <mat-select [(value)]="delimiter">
              @for (option of delimiterOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="file-upload-field">
            @if (!selectedFile) {
              <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">
                Select CSV File
              </button>
              <input #fileInput type="file" hidden accept=".csv" (change)="onFileSelected($event)">
            } @else {
              <div class="selected-file">
                <mat-icon>description</mat-icon>
                <span class="file-name">{{ selectedFile.name }}</span>
                <span class="file-size">({{ (selectedFile.size / 1024).toFixed(1) }} KB)</span>
                <button mat-icon-button type="button" (click)="removeFile()" matTooltip="Remove file" class="remove-file-btn">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- Check Result -->
    @if (checkResult) {
      <div class="component-box">
        <div class="result-header">
          <span class="result-title">Validation Result</span>
          @if (checkResult.success) {
            <mat-icon class="status-icon success">check_circle</mat-icon>
          } @else {
            <mat-icon class="status-icon error">error</mat-icon>
          }
        </div>
        @if (checkResult.success) {
          <div class="result-message success-message">
            <mat-icon>check_circle</mat-icon>
            <span>CSV file is valid and ready for import. {{ checkResult.totalRows }} rows found, {{ checkResult.validRows }} new.</span>
          </div>
          @if (checkResult.duplicateCount > 0) {
            <div class="result-message warning-message">
              <mat-icon>info</mat-icon>
              <span>{{ checkResult.duplicateCount }} duplicate(s) will be skipped:</span>
            </div>
            <div class="duplicate-list">
              @for (name of checkResult.duplicates; track name) {
                <div class="duplicate-item">
                  <mat-icon>content_copy</mat-icon>
                  <span>{{ name }}</span>
                </div>
              }
            </div>
          }
          @if (checkResult.countrySummaries.length) {
            <div class="country-summary">
              <span class="country-summary-title">New companies per country:</span>
              <div class="country-summary-list">
                @for (summary of checkResult.countrySummaries; track summary.countryName) {
                  <div class="country-summary-item">
                    <span class="country-name">{{ summary.countryName }}</span>
                    <span class="country-count">{{ summary.count }}</span>
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          <div class="result-message error-message">
            <mat-icon>error</mat-icon>
            <span>Validation failed. {{ checkResult.totalRows }} rows found, {{ checkResult.validRows }} valid, {{ checkResult.errors.length }} error(s):</span>
          </div>
          <div class="error-list">
            @for (error of checkResult.errors; track error) {
              <div class="error-item">
                <mat-icon>warning</mat-icon>
                <span>{{ error }}</span>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- Import Result -->
    @if (importResult) {
      <div class="component-box">
        <div class="result-header">
          <span class="result-title">Import Result</span>
          @if (importResult.success) {
            <mat-icon class="status-icon success">check_circle</mat-icon>
          } @else {
            <mat-icon class="status-icon error">error</mat-icon>
          }
        </div>
        @if (importResult.success) {
          <div class="result-message success-message">
            <mat-icon>check_circle</mat-icon>
            <span>Successfully imported {{ importResult.importedCount }} OPB companies.</span>
          </div>
          @if (importResult.duplicateCount > 0) {
            <div class="result-message warning-message">
              <mat-icon>info</mat-icon>
              <span>{{ importResult.duplicateCount }} duplicate(s) skipped.</span>
            </div>
          }
        } @else {
          <div class="result-message error-message">
            <mat-icon>error</mat-icon>
            <span>Import completed with errors. {{ importResult.importedCount }} companies imported.</span>
          </div>
          <div class="error-list">
            @for (error of importResult.errors; track error) {
              <div class="error-item">
                <mat-icon>warning</mat-icon>
                <span>{{ error }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button class="nrg-secondary-flat-button" type="button" (click)="onCheck()" [disabled]="!selectedFile || isChecking || isImporting">
      <mat-icon>fact_check</mat-icon>
      Validate
    </button>
    <button mat-flat-button color="accent" type="button" (click)="onImport()" [disabled]="!selectedFile || isChecking || isImporting">
      <mat-icon>cloud_upload</mat-icon>
      Import
    </button>
    <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onClose()">
      <mat-icon>clear</mat-icon>
      Close
    </button>
  </div>
</div>
